import { useMutation } from '@tanstack/react-query';
import {
  ContentTestsService,
  type GenerateAssetDto,
  type GeneratedAssetDto,
} from '@inference.engine/api-client/web';

import { inferenceHttp } from '@/lib/api/http-client';

export const DEFAULT_GENERATE_MODELS: Record<GenerateAssetDto['kind'], string> = {
  image: 'gemini-3-pro-image',
  video: 'veo-3.1',
};

export interface GenerateContentTestAssetInput {
  kind: GenerateAssetDto['kind'];
  prompt: string;
  platform: GenerateAssetDto['platform'];
  model?: string;
}

export const useGenerateContentTestAsset = () =>
  useMutation<GeneratedAssetDto, Error, GenerateContentTestAssetInput>({
    mutationFn: async ({ kind, prompt, platform, model }) => {
      const response = await ContentTestsService.generate({
        client: inferenceHttp,
        body: {
          kind,
          prompt,
          platform,
          model: model ?? DEFAULT_GENERATE_MODELS[kind],
        },
        throwOnError: true,
      });
      return response.data;
    },
  });
